import React from 'react';

import PageTemplate from './PageTemplate';
import { Button } from '../atom/Button';
import { Padding } from '../atom/Padding';
import { EmptyMessage } from '../organism/EmptyMessage';
import { InputForm } from '../organism/InputForm';

import { ERROR_CS, ERROR_VALIDATE } from '../../../lib/Error';

export const PasswordResetTemplate = ({
  check,
  state,
  onChangeValue,
  onSubmit,
}) => {
  return (
    <PageTemplate title="비밀번호 재설정">
      {check ? (
        <InputForm
          state={state}
          formData={RESET_DATA}
          onChangeValue={onChangeValue}
          onSubmit={onSubmit}
          size={3}
        >
          <Padding top={20}>
            <Button onClick={onSubmit} color="orangePink">
              비밀번호 변경
            </Button>
          </Padding>
        </InputForm>
      ) : (
        <EmptyMessage messageList={[`잘못된 URL입니다. ${ERROR_CS}`]} />
      )}
    </PageTemplate>
  );
};

const RESET_DATA = [
  {
    label: '비밀번호 변경',
    type: 'password',
    name: 'password',
    mainIconName: 'lock',
    subIconName: 'visibility',
    placeholder: '비밀번호를 입력해주세요.',
    errorMessage: ERROR_VALIDATE.password,
  },
  {
    label: null,
    type: 'password',
    name: 'confirmPassword',
    mainIconName: 'lock',
    subIconName: 'visibility',
    placeholder: '비밀번호를 확인해주세요.',
    errorMessage: ERROR_VALIDATE.passwordConfirm,
  },
];
